export default "__VITE_ASSET__B$UsLoU6__"